import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

const {
  FiArrowUpRight,
  FiCheck,
  FiClock,
  FiMonitor,
  FiPlay,
  FiShield,
} = FiIcons;

const benefits = [
  {icon: FiMonitor, text: 'Opens in a separate, presentation-ready window'},
  {icon: FiClock, text: 'Custom countdown with an automatic welcome reveal'},
  {icon: FiShield, text: 'No installation, extension, or fullscreen permission'},
];

function LaunchLanding({onLaunch, popupBlocked}) {
  return (
    <main className="launcher">
      <div className="launcher-orb launcher-orb-one" />
      <div className="launcher-orb launcher-orb-two" />

      <motion.header
        className="launcher-header"
        initial={{opacity: 0, y: -14}}
        animate={{opacity: 1, y: 0}}
      >
        <div className="brand-lockup">
          <span className="brand-symbol">P</span>
          <span>
            <b>Prosperity</b>
            <small>Launch Toolkit</small>
          </span>
        </div>
        <span className="browser-badge">
          <SafeIcon icon={FiCheck} />
          Browser ready
        </span>
      </motion.header>

      <section className="launcher-content">
        <motion.div
          className="launcher-copy"
          initial={{opacity: 0, y: 24}}
          animate={{opacity: 1, y: 0}}
          transition={{delay: 0.1, duration: 0.65}}
        >
          <span className="kicker">Your virtual event begins here</span>
          <h1>Launch with<br /><em>presence.</em></h1>
          <p>
            Create a polished countdown and welcome experience designed
            for effortless screen sharing.
          </p>

          <button className="launch-button" onClick={onLaunch}>
            <span className="launch-button-icon">
              <SafeIcon icon={FiPlay} />
            </span>
            <span>
              <b>Open Launch Window</b>
              <small>No installation required</small>
            </span>
            <SafeIcon icon={FiArrowUpRight} className="launch-arrow" />
          </button>

          {popupBlocked && (
            <div className="popup-warning">
              Your browser blocked the new window. Allow popups for this
              site, then click the launch button again.
            </div>
          )}
        </motion.div>

        <motion.div
          className="launcher-preview"
          initial={{opacity: 0, scale: 0.95, rotate: 1}}
          animate={{opacity: 1, scale: 1, rotate: 0}}
          transition={{delay: 0.2, duration: 0.75}}
        >
          <div className="preview-window">
            <div className="preview-bar">
              <i /><i /><i />
              <span>Launch window</span>
            </div>
            <div className="preview-stage">
              <span>We begin in</span>
              <strong>10:00</strong>
              <div className="preview-progress"><i /></div>
              <small>PROSPERITY • VIRTUAL LAUNCH</small>
            </div>
          </div>
          <div className="preview-card">
            <span>Optimized for</span>
            <b>Zoom &amp; screen sharing</b>
          </div>
        </motion.div>
      </section>

      <motion.footer
        className="launcher-benefits"
        initial={{opacity: 0}}
        animate={{opacity: 1}}
        transition={{delay: 0.65}}
      >
        {benefits.map(item => (
          <div key={item.text}>
            <SafeIcon icon={item.icon} />
            <span>{item.text}</span>
          </div>
        ))}
      </motion.footer>
    </main>
  );
}

export default LaunchLanding;
